<template>
    <ion-app>
        <app-header :title="'Handbuch 2019'" :back-button-title="'Zurück'" :back-button="goBack"></app-header>
        <ion-content>
            <iframe :src="'/web/viewer.html?file=' + url" style="width: 100%; height: 100%;"></iframe>
            <!--
            <PDFViewer
                ref="pdfViewer"
                v-bind="{ url }"
                :show-header="showHeader"
                @document-errored="onDocumentErrored"
            />

            -->
        </ion-content>
        <ion-footer>
            <TabBar :items="tabbarItems" :show-selection="false" @tab="tabClicked"></TabBar>
        </ion-footer>
    </ion-app>
</template>

<script>
import PDFViewer from '../components/PDFReader/PDFViewer';
import PDFSearchbar from '../components/PDFSearchbar';
import TabBar from '../components/TabBar';
export default {
    name: 'PDFView',
    components: {
        TabBar,
        PDFSearchbar,
        PDFViewer,
    },
    data() {
        return {
            tabbarItems: [
                { title: 'Dokumente', icon: 'back' },
                { title: 'Lesezeichen', icon: 'collection' },
            ],
            url: '/_001-480_Handbuch Fliesen_8A_Druck(1).pdf',
            documentError: undefined,
            showHeader: false,
        };
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {
        goBack() {
            this.$router.replace({ name: 'Dokumente' });
        },
        onDocumentErrored(e) {
            this.documentError = e.text;
        },
        toggleHeader() {
            this.showHeader = !this.showHeader;
        },
        tabClicked(index) {
            switch (index) {
                case 0:
                    this.goBack();
                    break;
                case 1:
                    this.$refs.pdfViewer.togglePreview();
                    break;
            }
        },
    },
};
</script>

<style lang="css" scoped>
#buttons {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
/* Page content */
.content {
    padding: 16px;
}
</style>
